import * as React from "react";

export const AiAvatarIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#3D86E0",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    color={color}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M9.181 2.345a.833.833 0 0 1 1.639 0l.875 4.632a1.67 1.67 0 0 0 1.329 1.328l4.631.876a.833.833 0 0 1 0 1.638l-4.631.876a1.67 1.67 0 0 0-1.329 1.329l-.876 4.631a.833.833 0 0 1-1.638 0l-.876-4.632a1.67 1.67 0 0 0-1.328-1.328l-4.632-.876a.833.833 0 0 1 0-1.638l4.632-.876a1.67 1.67 0 0 0 1.328-1.328zM16.667 1.667V5M18.333 3.334H15M3.334 18.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"
    ></path>
  </svg>
);
